export function generateStrongPassword(): string {
  const groups = ['ABCDEFGHJKLMNPQRSTUVWXYZ', 'abcdefghijkmnopqrstuvwxyz', '23456789', '!@#$%&*?'];
  const all = groups.join('');
  const required = groups.map((group) => pickSecure(group));
  const remaining = Array.from({ length: 14 }, () => pickSecure(all));
  return secureShuffle([...required, ...remaining]).join('');
}

function pickSecure(characters: string): string {
  return characters[secureIndex(characters.length)]!;
}

function secureShuffle(values: string[]): string[] {
  for (let index = values.length - 1; index > 0; index -= 1) {
    const target = secureIndex(index + 1);
    [values[index], values[target]] = [values[target]!, values[index]!];
  }
  return values;
}

function secureIndex(max: number): number {
  const values = new Uint32Array(1);
  crypto.getRandomValues(values);
  return values[0]! % max;
}
